<i18n>
{
  "fr": {
      "workflow": "Suivi de la demande",
      "please_note_after_validation_you_will_no_longer_be_able_to_modify_the_survey_form": "Attention, après validation, vous ne pourrez plus modifier le formulaire d'enquête",
      "submit": "Sauvegarder",
      "loading": "Chargement...",
      "comment": "Commentaire"
  }
}
</i18n>
<template>
  <div v-if="loading || nextStatuses.length != 0" class="panel panel-info text-left">
    <div class="panel-heading">
      <h3>{{ $t('workflow')}}</h3>
    </div>
    <div class="panel-body">
      <template v-if="loading">
        <strong>{{$t('loading')}}</strong>
        <b-spinner class="ml-auto"></b-spinner>
      </template>
      <form v-else id="workflow" name="dynamic-validation" @submit.prevent="handleSubmitWorkflow">
          <b-row class="mb-4">
                  <b-col sm="2">
                    <label for="textarea-small">{{$t('comment')}}</label>
                  </b-col>
                  <b-col sm="10">
                        <textarea
                          name="comment"
                          size="sm"
                          class="form-control"
                          v-model="workflowForm.comment"
                          rows="20"
                          cols="20"
                          max-rows="255"
                          :maxlength="$MAX_2000"
                          style="min-height:200px"
                        />
                  </b-col>
                  <b-col sm="12" class="text-right"><span>{{charactersRemaining}}/{{$MAX_2000}}</span></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Statut" label-cols-sm="12" label-for="status" class="disp-msg">
              <b-form-radio-group
                id="status"
                buttons
                v-model="workflowForm.status"
                name="status"
                button-variant="outline-info"
                size="lg"
              >
                <b-form-radio
                  v-for="status in nextStatuses"
                  :key="status.id"
                  :value="status.id"
                  :disabled="validatForm(status.id)"
                >{{ status.label }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <span v-if="this.workflowDisable" class="ndisp red">Date de visite non saisie</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="submit-form">
            <b-button type="submit" class="btn btn-cta s-btn">
              <b-spinner v-if="submit" />
              {{ $t('submit') }}
            </b-button>
          </b-col>
        </b-row>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Workflow',
  data: () => ({
    submit: false,
    loading: true,
    workflowDisable: false,
  }),
  props: ['controlForm'],
  created() {
    this.initWorkflowForm();
    this.initNotif();
    this.fetchNextStatuses();
  },
  mounted() {
    this.validatForm();
  },
  computed: {
    ...mapState({
      property: state => state.refProperties.property,
      workflowForm: state => state.workflow.workflowForm,
      nextStatuses: state => state.workflow.nextStatuses,
    }),
    charactersRemaining: function () {
      if(   this.workflowForm.comment )
       {
         return this.workflowForm.comment.length;
       }
       return 0;
      },
  },
  methods: {
    ...mapActions(['initWorkflowForm', 'initNotif']),
    validatForm(stat) {
      if (this.controlForm.dateOfVisit === null && stat === 'waitingForValidation') {
        this.workflowDisable = true;
        return true;
      }
      return false;
    },
    fetchNextStatuses() {
      this.$store.dispatch('fetchNextStatuses').then(() => (this.loading = false));
    },
    handleSubmitWorkflow() {
      if (this.workflowForm.status == 'validated') {
        if (! confirm(this.$t('please_note_after_validation_you_will_no_longer_be_able_to_modify_the_survey_form'))) {
          return false;
        }
      }

      this.submit = true;
      this.$store.dispatch('handleSubmitWorkflow');
    },
  },
};
</script>
<style >
.display-no {
  visibility: hidden;
}
</style>
